import { WHITE_COLOR } from "../resources/colorsManager";

const Empty = ({ children }) => (
  <div
    style={{
      width: "100%",
      backgroundColor: WHITE_COLOR,
    }}
  >
    {children}
  </div>
);

export default Empty;
